import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { AuthenticationService } from "../../../shared/services/authentication.service";
import { Output, EventEmitter } from "@angular/core";
import { ModalService } from "src/app/shared/modal.service";
import { GuidedTourService } from "../../guided-tour.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-resources-header",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.scss"],
})
export class AppResourcesHeaderComponent implements OnInit {
  @Input() _status: boolean;
  changeNav: boolean;
  is_authenticated: boolean;
  host_url: string;
  @Output() close = new EventEmitter<void>();
  showModal = false;
  currentStep = 0;
  totalSteps = 2;
  showTourBanner = true;
  private routerSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private modalService: ModalService,
    private guidedServ: GuidedTourService
  ) {}
  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    // this.guidedServ.setStartTour(1)

    const did_user_close_tour = localStorage.getItem("did_user_close_tour");
    this.showTourBanner =
      did_user_close_tour == "yes" ? false : this.showTourBanner;

    this.host_url = environment.host_url;
    this.is_authenticated = this.authenticationService.isAuthenticated();
    this.checkPathAndCloseBanner();
    this.modalService.showHeaderModal$.subscribe(() => {
      this.open(); // This opens the walkthrough modal
    });

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Check if the current URL is not the root path
        const tree = this.router.parseUrl(event.urlAfterRedirects);
        const segments = tree.root.children["primary"]
          ? tree.root.children["primary"].segments
          : [];

        const path = segments
          .map(function (segment) {
            return segment.path;
          })
          .join("/");

        this.showTourBanner = path === "";
      });
  }

  checkPathAndCloseBanner() {
    const tree = this.router.parseUrl(this.router.url);
    const segments = tree.root.children["primary"]
      ? tree.root.children["primary"].segments
      : [];

    const path = segments
      .map(function (segment) {
        return segment.path;
      })
      .join("/");
    console.log("PATH", path);
    if (path !== "") {
      this.showTourBanner = false;
    } else {
      this.showTourBanner = true;
    }
  }

  open() {
    localStorage.setItem("selectedTab", "measures");
    this.showModal = true;
    this.currentStep = 0;
    document.body.style.overflow = "hidden"; // Prevent scrolling

    this.modalService.changeTab("tour-start");
  }

  closeTourBanner() {
    this.showTourBanner = false;
    localStorage.setItem("did_user_close_tour", "yes");
  }

  closeModal() {
    this.showModal = false;
    document.body.style.overflow = "auto"; // Restore scrolling
    this.close.emit();
  }

  skipTour() {
    this.closeModal();
  }

  explore() {
    // Move to the next step instead of closing
    this.currentStep = 1;
    console.log("CURRENT STEP", this.currentStep);
  }

  nextStep() {
    this.modalService.triggerShowMeasuresModal();
    this.closeModal();
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  // For clicking outside to close
  onOverlayClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }
}
